module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "main"
  }, [_c('ui-sidebar'), _vm._v(" "), _c('div', {
    staticClass: "group group--sidebar f2f"
  }, [_c('module-questionnaire', {
    attrs: {
      "intake-id": "f2f",
      "next-route-prefix": "face2face",
      "on-complete-route": _vm.onCompleteRoute,
      "loading": _vm.loadingSingleQuestion
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "group group--df-column hide-above-large hide-below-medium mt-auto mb2"
  }, [_c('p', {
    staticClass: "c-accent mw300 fs-14"
  }, [_vm._v("Face to face requests take up to 10 business days for a response. Dont want to wait that long?")]), _vm._v(" "), _c('router-link', {
    staticClass: "c-accent mw300 fs-14",
    attrs: {
      "to": {
        name: "results"
      }
    }
  }, [_vm._v("Schedule a telehelath appointment today")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-19f0483f"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/appointment/Face2face.vue
// module id = 472
// module chunks = 0